module.exports = __webpack_public_path__ + "img/weidengl.fa940446.png";